<template>
  <el-select
    v-model="dataValue"
    style="width: 200px;"
    placeholder="请选择联系状态">
    <el-option
      v-for="item in consumablesList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: 'StatusSelect',
  props: ['value'],
  data() {
    return {
      consumablesList: [{ label: '未联系', value: 0 }, { label: '已联系', value: 1 }]
    }
  },
  computed: {
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
